export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/905346818688"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer"
      aria-label="WhatsApp ile iletişime geç"
    >
      <i className="ri-whatsapp-fill text-white text-3xl"></i>
    </a>
  );
}
